export const FUTURE_MEMBER_VERIFICATION = {
  title: "Profile verification",
  statusTag: "Coming in the future",
  discoveryCaption: "Profile verification coming in the future",
  body:
    "Kindred is preparing optional Persona identity checks to help members confirm who they are. This is not live yet and should not be read as a sign that this member has already been reviewed or guaranteed safe.",
} as const;
